import { render, staticRenderFns } from "./Localization.vue?vue&type=template&id=076c56c6&scoped=true&"
import script from "./Localization.vue?vue&type=script&lang=ts&"
export * from "./Localization.vue?vue&type=script&lang=ts&"
import style0 from "./Localization.vue?vue&type=style&index=0&id=076c56c6&lang=scss&scoped=true&"
import style1 from "./Localization.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076c56c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VApp,VBtn,VIcon,VSelect,VTextField})
